import { render, staticRenderFns } from "./wy-evaluation-preview.vue?vue&type=template&id=4881a9de&scoped=true&"
import script from "./wy-evaluation-preview.vue?vue&type=script&lang=js&"
export * from "./wy-evaluation-preview.vue?vue&type=script&lang=js&"
import style0 from "./wy-evaluation-preview.vue?vue&type=style&index=0&id=4881a9de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4881a9de",
  null
  
)

export default component.exports